
// // import React, { useState, useRef, useEffect } from 'react';
// // import { postData, getData, serverURL } from '../../../../services/Fetchnodeservices';
// // import { Image as ImageIcon, Sparkles, X, Plus, CloudUpload, History, ListCheck } from 'lucide-react';
// // import ImageSearchModal from './ImageSearchModal';

// // const AIScanModal = ({ 
// //   isOpen, 
// //   onClose, 
// //   designationId, 
// //   restaurantName, 
// //   onItemsAdded, 
// //   preSelectedServerImage,
// //   markupCommission = 20,    // new: for calculating customer price
// //   profitCommission = 20     // new: for calculating platform profit
// // }) => {
// //     const [step, setStep] = useState('select-source');
// //     const [loadingStep, setLoadingStep] = useState("");
// //     const [selectedFile, setSelectedFile] = useState(null);
// //     const [serverFileName, setServerFileName] = useState("");
// //     const [previewUrl, setPreviewUrl] = useState("");
// //     const [scanResults, setScanResults] = useState([]);
// //     const [vendorImages, setVendorImages] = useState([]);
// //     const [loadingImages, setLoadingImages] = useState(false);
// //     const [saving, setSaving] = useState(false);
// //     const [isBulkSearching, setIsBulkSearching] = useState(false);
// //     const [showImageFinder, setShowImageFinder] = useState(false);
// //     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
// //     const [searchQuery, setSearchQuery] = useState("");
// //     const fileInputRef = useRef(null);

// //     useEffect(() => {
// //         if (isOpen) {
// //             if (preSelectedServerImage) {
// //                 setServerFileName(preSelectedServerImage);
// //                 setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
// //                 setStep('upload');
// //             } else {
// //                 setStep('select-source');
// //                 setServerFileName("");
// //                 setSelectedFile(null);
// //                 setPreviewUrl("");
// //             }
// //             setScanResults([]);
// //         }
// //     }, [isOpen, preSelectedServerImage]);

// //     // ---- Pricing helpers using both commissions ----
// //     const computePrices = (menuPrice) => {
// //         const m = parseFloat(menuPrice) || 0;
// //         const customer = Math.round(m * (1 + markupCommission / 100));
// //         const profit = Math.round(customer * (profitCommission / 100));
// //         const vendor = customer - profit;
// //         return { menu: m, customer, vendor, profit };
// //     };

// //     const computeVariantPrices = (menuPrice) => {
// //         const m = parseFloat(menuPrice) || 0;
// //         const customer = Math.round(m * (1 + markupCommission / 100));
// //         const profit = Math.round(customer * (profitCommission / 100));
// //         const vendor = customer - profit;
// //         return { customer, vendor, profit };
// //     };

// //     const autoFetchAllImages = async () => {
// //         setIsBulkSearching(true);
// //         const updated = [...scanResults];
// //         for (let i = 0; i < updated.length; i++) {
// //             try {
// //                 setLoadingStep(`✨ Finding image for: ${updated[i].name}...`);
// //                 const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
// //                 if (resp.success && resp.images.length > 0) {
// //                     updated[i].pic1 = resp.images[0].url;
// //                     setScanResults([...updated]);
// //                 }
// //             } catch (e) { console.error(e); }
// //         }
// //         setIsBulkSearching(false);
// //         setLoadingStep("");
// //     };

// //     const fetchVendorImages = async () => {
// //         setLoadingImages(true);
// //         setStep('vendor-images');
// //         try {
// //             const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
// //             if (resp.success) {
// //                 const allFiles = [];
// //                 resp.data.forEach(req => {
// //                     const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
// //                     files.forEach(f => {
// //                         if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
// //                     });
// //                 });
// //                 setVendorImages(allFiles);
// //             }
// //         } catch (e) { console.error(e); }
// //         finally { setLoadingImages(false); }
// //     };

// //     const handleVendorImageSelect = (filename) => {
// //         setServerFileName(filename);
// //         setPreviewUrl(`${serverURL}/uploads /${filename}`);
// //         setStep('upload');
// //     };

// //     const startScan = async () => {
// //         setStep('scanning');
// //         setLoadingStep("🧠 AI is reading the menu...");
// //         const formData = new FormData();
// //         if (selectedFile) formData.append("file", selectedFile);
// //         else formData.append("serverFileName", serverFileName);
// //         formData.append("designation_id", designationId);
// //         formData.append("instructions", "Extract item names, prices, variants, veg/non-veg, and a short description.");

// //         try {
// //             const resp = await postData("aimenu/ai-scan", formData);
// //             if (resp.success) {
// //                 setScanResults(resp.new_items.map(i => ({
// //                     ...i,
// //                     tempId: Math.random().toString(36).substr(2, 9),
// //                     selected: true,
// //                     price: i.price || 0,               // menu price (base)
// //                     base_price: i.price || 0,
// //                     variants: i.variants?.map(v => ({ 
// //                         ...v, 
// //                         price: v.price || v.item_price_variant || 0,
// //                         base_price: v.price || v.item_price_variant || 0
// //                     })) || [],
// //                     description: i.description || ""
// //                 })));
// //                 setStep('results');
// //             } else { setStep('select-source'); }
// //         } catch (err) { setStep('select-source'); }
// //     };

// //     const handleSaveItems = async () => {
// //         setSaving(true);
// //         const finalItems = scanResults.filter(i => i.selected).map(item => {
// //             const menuPrice = parseFloat(item.price) || 0;
// //             const p = computePrices(menuPrice);

// //             const formattedVariants = (item.variants || []).map(v => {
// //                 const variantMenu = parseFloat(v.price) || 0;
// //                 const { customer: vCust, vendor: vVendor, profit: vProfit } = computeVariantPrices(variantMenu);
// //                 return {
// //                     unit: (v.unit_value || "Price").toLowerCase(),
// //                     unit_value: v.unit_value || "Price",
// //                     base_price: variantMenu,
// //                     actual_price: variantMenu,
// //                     item_price_variant: vCust,
// //                     is_available_variant: "yes"
// //                 };
// //             });

// //             return {
// //                 ...item,
// //                 base_price: menuPrice,
// //                 requested_price: menuPrice,
// //                 price: p.customer,              // customer price
// //                 status: "1",
// //                 source: "ai_scan",
// //                 variant: formattedVariants,
// //                 description: item.description || ""
// //             };
// //         });

// //         try {
// //             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
// //             if (resp.success) { onItemsAdded(); onClose(); }
// //         } catch (e) { console.error(e); }
// //         finally { setSaving(false); }
// //     };

// //     const handleImageSelect = (imgUrl) => {
// //         if (currentSearchIndex !== null) {
// //             setScanResults(prev => {
// //                 const updated = [...prev];
// //                 if (updated[currentSearchIndex]) {
// //                     updated[currentSearchIndex].pic1 = imgUrl;
// //                 }
// //                 return updated;
// //             });
// //         }
// //         setShowImageFinder(false);
// //     };

// //     if (!isOpen) return null;

// //     return (
// //         <div style={styles.overlay} onClick={showImageFinder ? undefined : onClose}>
// //             <div style={styles.modal} onClick={e => e.stopPropagation()}>
// //                 <div style={styles.header}>
// //                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
// //                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
// //                         <h3 style={{margin:0, fontSize:'18px'}}>🤖 AI Scanner – {restaurantName}</h3>
// //                     </div>
// //                     {scanResults.length > 0 && (
// //                         <div style={styles.countBadge}>
// //                             <ListCheck size={14} /> {scanResults.length} items
// //                         </div>
// //                     )}
// //                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
// //                 </div>

// //                 <div style={styles.body}>
// //                     {step === 'select-source' ? (
// //                         <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
// //                             <div style={styles.sourceCard} onClick={() => setStep('upload')}>
// //                                 <CloudUpload size={40} color="#a855f7" />
// //                                 <h3 style={{color:'white'}}>Upload File</h3>
// //                                 <p style={{color:'#94a3b8'}}>From your device</p>
// //                             </div>
// //                             <div style={styles.sourceCard} onClick={fetchVendorImages}>
// //                                 <History size={40} color="#3b82f6" />
// //                                 <h3 style={{color:'white'}}>Vendor Menu</h3>
// //                                 <p style={{color:'#94a3b8'}}>Previously uploaded</p>
// //                             </div>
// //                         </div>
// //                     ) : step === 'vendor-images' ? (
// //                         <div>
// //                             <button onClick={()=>setStep('select-source')} style={styles.backBtn}>← Back</button>
// //                             {loadingImages ? <div className="loader"></div> : (
// //                                 <div style={styles.grid}>
// //                                     {vendorImages.map((img, i) => (
// //                                         <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
// //                                             <img src={`${serverURL}/uploads/${img.name}`} alt="menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
// //                                             <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
// //                                         </div>
// //                                     ))}
// //                                 </div>
// //                             )}
// //                         </div>
// //                     ) : step === 'upload' ? (
// //                         <div style={{textAlign:'center'}}>
// //                             <button onClick={()=>setStep('select-source')} style={styles.backBtnLeft}>← Change</button>
// //                             <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
// //                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
// //                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
// //                             </div>
// //                             <button style={styles.btnPrimary} onClick={startScan}>🔍 Start AI Scan</button>
// //                         </div>
// //                     ) : (step === 'scanning' || isBulkSearching) ? (
// //                         <div style={{textAlign:'center', padding:'80px'}}>
// //                             <div className="loader"></div>
// //                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
// //                         </div>
// //                     ) : (
// //                         <>
// //                             <div style={{display:'flex', gap:'10px', marginBottom:'20px', alignItems:'center', justifyContent:'space-between'}}>
// //                                 <div style={{display:'flex', gap:'10px'}}>
// //                                     <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "💾 Add Items"}</button>
// //                                     <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> ✨ Auto Images</button>
// //                                 </div>
// //                                 <div style={{color:'#94a3b8', fontSize:'14px', fontWeight:600}}>{scanResults.length} items</div>
// //                             </div>
// //                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
// //                                 {scanResults.map((item, idx) => {
// //                                     const { menu, customer, vendor, profit } = computePrices(item.price);
// //                                     return (
// //                                         <div key={item.tempId} style={styles.itemCard}>
// //                                             <div style={{display:'flex', gap:'15px'}}>
// //                                                 <div style={{width:'110px', textAlign:'center'}}>
// //                                                     <img
// //                                                         src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`}
// //                                                         style={styles.thumb}
// //                                                         onError={e => { e.target.onerror = null; e.target.src = "https://placehold.co/100x100?text=No+Image"; }}
// //                                                         alt="dish"
// //                                                     />
// //                                                     <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Better Image</button>
// //                                                 </div>
// //                                                 <div style={{flex:1}}>
// //                                                     <div style={{display:'flex', gap:'10px'}}>
// //                                                         <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
// //                                                         <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
// //                                                     </div>

// //                                                     <div style={styles.basePriceRow}>
// //                                                         <span style={styles.basePriceLabel}>Menu Price ₹</span>
// //                                                         <input
// //                                                             type="number"
// //                                                             style={styles.inputPrice}
// //                                                             value={item.price}
// //                                                             onChange={e => { const nr=[...scanResults]; nr[idx].price = e.target.value; nr[idx].base_price = e.target.value; setScanResults(nr); }}
// //                                                         />
// //                                                         <span style={{color:'#fbbf24', fontSize:'11px'}}>Customer: ₹{customer}</span>
// //                                                         <span style={{color:'#a855f7', fontSize:'11px'}}>Vendor: ₹{vendor}</span>
// //                                                         <span style={{color:'#34d399', fontSize:'11px'}}>Profit: ₹{profit}</span>
// //                                                         {(!item.price || item.price === 0) && (
// //                                                             <span style={styles.priceWarning}>⚠ No price found — please check manually</span>
// //                                                         )}
// //                                                     </div>

// //                                                     <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />

// //                                                     <div style={styles.variantBox}>
// //                                                         <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
// //                                                             {item.variants.map((v, vIdx) => {
// //                                                                 const { customer: vCust, vendor: vVendor, profit: vProfit } = computeVariantPrices(v.price);
// //                                                                 return (
// //                                                                     <div key={vIdx} style={styles.vRow}>
// //                                                                         <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
// //                                                                         <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; nr[idx].variants[vIdx].base_price=e.target.value; setScanResults(nr)}} />
// //                                                                         <span style={{color:'#fbbf24', fontSize:'10px'}}>C:₹{vCust}</span>
// //                                                                         <span style={{color:'#a855f7', fontSize:'10px'}}>V:₹{vVendor}</span>
// //                                                                         <span style={{color:'#34d399', fontSize:'10px'}}>P:₹{vProfit}</span>
// //                                                                         <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={styles.delBtn}><X size={12}/></button>
// //                                                                     </div>
// //                                                                 );
// //                                                             })}
// //                                                             <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0, base_price:0}); setScanResults(nr)}}>+ Price</button>
// //                                                         </div>
// //                                                     </div>
// //                                                 </div>
// //                                             </div>
// //                                         </div>
// //                                     );
// //                                 })}
// //                             </div>
// //                         </>
// //                     )}
// //                 </div>
// //             </div>

// //             {showImageFinder && (
// //                 <div onClick={e => e.stopPropagation()} style={{ position: 'relative', zIndex: 10000 }}>
// //                     <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={handleImageSelect} />
// //                 </div>
// //             )}
// //             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
// //         </div>
// //     );
// // };

// // const styles = {
// //     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
// //     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
// //     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
// //     countBadge: { background: '#a855f722', color: '#a855f7', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' },
// //     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
// //     body: { flex: 1, overflowY: 'auto', padding: '20px' },
// //     backBtn: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', fontWeight:600 },
// //     backBtnLeft: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left', fontWeight:600 },
// //     sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
// //     grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
// //     imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
// //     imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
// //     dropZone: { height: '220px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow:'hidden', clear:'both' },
// //     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
// //     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
// //     thumb: { width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover', border:'1px solid #1f1f1f' },
// //     findBtn: { width:'100%', background: '#a855f722', border: 'none', color: '#a855f7', fontSize: '10px', padding: '6px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', fontWeight:600 },
// //     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '18px', fontWeight: 700, flex: 1, outline: 'none' },
// //     basePriceRow: { display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', background: '#161616', border: '1px solid #334155', borderRadius: '8px', padding: '8px 10px', flexWrap: 'wrap' },
// //     basePriceLabel: { color: '#a855f7', fontSize: '12px', fontWeight: 700 },
// //     priceWarning: { color: '#f59e0b', fontSize: '11px', fontWeight: 600 },
// //     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '12px', padding: '10px', marginTop: '10px', resize: 'none', outline: 'none', minHeight:'50px' },
// //     variantBox: { background: '#161616', padding: '10px', borderRadius: '8px', marginTop: '10px' },
// //     vRow: { display: 'flex', alignItems: 'center', gap: '8px', background: '#0a0a0a', padding: '5px 10px', borderRadius: '6px', border: '1px solid #1f1f1f' },
// //     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '70px', fontSize: '12px', fontWeight: 'bold', outline: 'none' },
// //     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '70px', padding: '4px', textAlign: 'center', fontSize: '12px', outline: 'none' },
// //     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
// //     btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight:600 },
// //     addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '11px', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight:600 },
// //     delBtn: { background:'none', border:'none', color:'#f87171', cursor:'pointer' },
// //     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '5px', fontSize: '12px' },
// //     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// // };

// // export default AIScanModal;


// import React, { useState, useRef, useEffect } from 'react';
// import { postData, getData, serverURL } from '../../../../services/Fetchnodeservices';
// import { Image as ImageIcon, Sparkles, X, Plus, CloudUpload, History, ListCheck } from 'lucide-react';
// import ImageSearchModal from './ImageSearchModal';

// const AIScanModal = ({ 
//   isOpen, 
//   onClose, 
//   designationId, 
//   restaurantName, 
//   onItemsAdded, 
//   preSelectedServerImage,
//   markupCommission = 20,    // new: for calculating customer price
//   profitCommission = 20     // new: for calculating platform profit
// }) => {
//     const [step, setStep] = useState('select-source');
//     const [loadingStep, setLoadingStep] = useState("");
//     const [selectedFile, setSelectedFile] = useState(null);
//     const [serverFileName, setServerFileName] = useState("");
//     const [previewUrl, setPreviewUrl] = useState("");
//     const [scanResults, setScanResults] = useState([]);
//     const [vendorImages, setVendorImages] = useState([]);
//     const [loadingImages, setLoadingImages] = useState(false);
//     const [saving, setSaving] = useState(false);
//     const [isBulkSearching, setIsBulkSearching] = useState(false);
//     const [showImageFinder, setShowImageFinder] = useState(false);
//     const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
//     const [searchQuery, setSearchQuery] = useState("");
//     const fileInputRef = useRef(null);

//     useEffect(() => {
//         if (isOpen) {
//             if (preSelectedServerImage) {
//                 setServerFileName(preSelectedServerImage);
//                 setPreviewUrl(`${serverURL}/uploads/${preSelectedServerImage}`);
//                 setStep('upload');
//             } else {
//                 setStep('select-source');
//                 setServerFileName("");
//                 setSelectedFile(null);
//                 setPreviewUrl("");
//             }
//             setScanResults([]);
//         }
//     }, [isOpen, preSelectedServerImage]);

//     // ---- Pricing helpers using both commissions ----
//     const computePrices = (menuPrice) => {
//         const m = parseFloat(menuPrice) || 0;
//         const customer = Math.round(m * (1 + markupCommission / 100));
//         const profit = Math.round(customer * (profitCommission / 100));
//         const vendor = customer - profit;
//         return { menu: m, customer, vendor, profit };
//     };

//     const computeVariantPrices = (menuPrice) => {
//         const m = parseFloat(menuPrice) || 0;
//         const customer = Math.round(m * (1 + markupCommission / 100));
//         const profit = Math.round(customer * (profitCommission / 100));
//         const vendor = customer - profit;
//         return { customer, vendor, profit };
//     };

//     const autoFetchAllImages = async () => {
//         setIsBulkSearching(true);
//         const updated = [...scanResults];
//         for (let i = 0; i < updated.length; i++) {
//             try {
//                 setLoadingStep(`✨ Finding image for: ${updated[i].name}...`);
//                 const resp = await postData("aimenu/search-web-images", { query: updated[i].name });
//                 if (resp.success && resp.images.length > 0) {
//                     updated[i].pic1 = resp.images[0].url;
//                     setScanResults([...updated]);
//                 }
//             } catch (e) { console.error(e); }
//         }
//         setIsBulkSearching(false);
//         setLoadingStep("");
//     };

//     const fetchVendorImages = async () => {
//         setLoadingImages(true);
//         setStep('vendor-images');
//         try {
//             const resp = await getData(`menuScanner/requests-by-restaurant/${designationId}`);
//             if (resp.success) {
//                 const allFiles = [];
//                 resp.data.forEach(req => {
//                     const files = Array.isArray(req.files) ? req.files : JSON.parse(req.files || '[]');
//                     files.forEach(f => {
//                         if (f.type === 'image') allFiles.push({ ...f, created_at: req.created_at });
//                     });
//                 });
//                 setVendorImages(allFiles);
//             }
//         } catch (e) { console.error(e); }
//         finally { setLoadingImages(false); }
//     };

//     const handleVendorImageSelect = (filename) => {
//         setServerFileName(filename);
//         setPreviewUrl(`${serverURL}/uploads /${filename}`);
//         setStep('upload');
//     };

//     const startScan = async () => {
//         setStep('scanning');
//         setLoadingStep("🧠 AI is reading the menu...");
//         const formData = new FormData();
//         if (selectedFile) formData.append("file", selectedFile);
//         else formData.append("serverFileName", serverFileName);
//         formData.append("designation_id", designationId);
//         formData.append("instructions", "Extract item names, prices, variants, veg/non-veg, and a short description.");

//         try {
//             const resp = await postData("aimenu/ai-scan", formData);
//             if (resp.success) {
//                 setScanResults(resp.new_items.map(i => ({
//                     ...i,
//                     tempId: Math.random().toString(36).substr(2, 9),
//                     selected: true,
//                     price: i.price || 0,               // menu price (base)
//                     base_price: i.price || 0,
//                     variants: i.variants?.map(v => ({ 
//                         ...v, 
//                         price: v.price || v.item_price_variant || 0,
//                         base_price: v.price || v.item_price_variant || 0
//                     })) || [],
//                     description: i.description || ""
//                 })));
//                 setStep('results');
//             } else { setStep('select-source'); }
//         } catch (err) { setStep('select-source'); }
//     };

//     const handleSaveItems = async () => {
//         setSaving(true);
//         const finalItems = scanResults.filter(i => i.selected).map(item => {
//             const menuPrice = parseFloat(item.price) || 0;
//             const p = computePrices(menuPrice);

//             const formattedVariants = (item.variants || []).map(v => {
//                 const variantMenu = parseFloat(v.price) || 0;
//                 const { customer: vCust, vendor: vVendor, profit: vProfit } = computeVariantPrices(variantMenu);
//                 return {
//                     unit: (v.unit_value || "Price").toLowerCase(),
//                     unit_value: v.unit_value || "Price",
//                     base_price: variantMenu,
//                     actual_price: variantMenu,
//                     item_price_variant: vCust,
//                     is_available_variant: "yes"
//                 };
//             });

//             return {
//                 ...item,
//                 base_price: menuPrice,
//                 requested_price: menuPrice,
//                 price: p.customer,              // customer price
//                 status: "1",
//                 source: "ai_scan",
//                 variant: formattedVariants,
//                 description: item.description || ""
//             };
//         });

//         try {
//             const resp = await postData(`menu/direct-items/${designationId}`, { items: finalItems });
//             if (resp.success) { onItemsAdded(); onClose(); }
//         } catch (e) { console.error(e); }
//         finally { setSaving(false); }
//     };

//     const handleImageSelect = (imgUrl) => {
//         if (currentSearchIndex !== null) {
//             setScanResults(prev => {
//                 const updated = [...prev];
//                 if (updated[currentSearchIndex]) {
//                     updated[currentSearchIndex].pic1 = imgUrl;
//                 }
//                 return updated;
//             });
//         }
//         setShowImageFinder(false);
//     };

//     if (!isOpen) return null;

//     return (
//         <div style={styles.overlay} onClick={showImageFinder ? undefined : onClose}>
//             <div style={styles.modal} onClick={e => e.stopPropagation()}>
//                 <div style={styles.header}>
//                     <div style={{display:'flex', alignItems:'center', gap:'12px'}}>
//                         <div style={styles.aiIcon}><Sparkles size={18} fill="white"/></div>
//                         <h3 style={{margin:0, fontSize:'18px'}}>🤖 AI Scanner – {restaurantName}</h3>
//                     </div>
//                     {scanResults.length > 0 && (
//                         <div style={styles.countBadge}>
//                             <ListCheck size={14} /> {scanResults.length} items
//                         </div>
//                     )}
//                     <button onClick={onClose} style={styles.closeBtn}><X /></button>
//                 </div>

//                 <div style={styles.body}>
//                     {step === 'select-source' ? (
//                         <div style={{display:'flex', gap:'20px', justifyContent:'center', padding:'40px', flexWrap:'wrap'}}>
//                             <div style={styles.sourceCard} onClick={() => setStep('upload')}>
//                                 <CloudUpload size={40} color="#a855f7" />
//                                 <h3 style={{color:'white'}}>Upload File</h3>
//                                 <p style={{color:'#94a3b8'}}>From your device</p>
//                             </div>
//                             <div style={styles.sourceCard} onClick={fetchVendorImages}>
//                                 <History size={40} color="#3b82f6" />
//                                 <h3 style={{color:'white'}}>Vendor Menu</h3>
//                                 <p style={{color:'#94a3b8'}}>Previously uploaded</p>
//                             </div>
//                         </div>
//                     ) : step === 'vendor-images' ? (
//                         <div>
//                             <button onClick={()=>setStep('select-source')} style={styles.backBtn}>← Back</button>
//                             {loadingImages ? <div className="loader"></div> : (
//                                 <div style={styles.grid}>
//                                     {vendorImages.map((img, i) => (
//                                         <div key={i} style={styles.imgPick} onClick={() => handleVendorImageSelect(img.name)}>
//                                             <img src={`${serverURL}/uploads/${img.name}`} alt="menu" style={{width:'100%', height:'120px', objectFit:'cover'}} />
//                                             <div style={styles.imgLabel}>{new Date(img.created_at).toLocaleDateString()}</div>
//                                         </div>
//                                     ))}
//                                 </div>
//                             )}
//                         </div>
//                     ) : step === 'upload' ? (
//                         <div style={{textAlign:'center'}}>
//                             <button onClick={()=>setStep('select-source')} style={styles.backBtnLeft}>← Change</button>
//                             <div style={styles.dropZone} onClick={() => !serverFileName && fileInputRef.current.click()}>
//                                 <input type="file" ref={fileInputRef} onChange={e => {setSelectedFile(e.target.files[0]); setPreviewUrl(URL.createObjectURL(e.target.files[0]))}} hidden />
//                                 {previewUrl ? <img src={previewUrl} style={{maxHeight:'100%', borderRadius:'8px'}} alt="preview" /> : <ImageIcon size={48} color="#334155" />}
//                             </div>
//                             <button style={styles.btnPrimary} onClick={startScan}>🔍 Start AI Scan</button>
//                         </div>
//                     ) : (step === 'scanning' || isBulkSearching) ? (
//                         <div style={{textAlign:'center', padding:'80px'}}>
//                             <div className="loader"></div>
//                             <h3 style={{marginTop:'20px', color:'#a855f7'}}>{loadingStep}</h3>
//                         </div>
//                     ) : (
//                         <>
//                             <div style={{display:'flex', gap:'10px', marginBottom:'20px', alignItems:'center', justifyContent:'space-between'}}>
//                                 <div style={{display:'flex', gap:'10px'}}>
//                                     <button style={styles.btnBlue} onClick={handleSaveItems}>{saving ? "Saving..." : "💾 Add Items"}</button>
//                                     <button style={styles.btnMagic} onClick={autoFetchAllImages}><Sparkles size={14}/> ✨ Auto Images</button>
//                                 </div>
//                                 <div style={{color:'#94a3b8', fontSize:'14px', fontWeight:600}}>{scanResults.length} items</div>
//                             </div>
//                             <div style={{display:'flex', flexDirection:'column', gap:'12px'}}>
//                                 {scanResults.map((item, idx) => {
//                                     const { menu, customer, vendor, profit } = computePrices(item.price);
//                                     return (
//                                         <div key={item.tempId} style={styles.itemCard}>
//                                             <div style={{display:'flex', gap:'15px'}}>
//                                                 <div style={{width:'110px', textAlign:'center'}}>
//                                                     <img
//                                                         src={item.pic1?.startsWith('http') ? item.pic1 : `${serverURL}/uploads/${item.pic1}`}
//                                                         style={styles.thumb}
//                                                         onError={e => { e.target.onerror = null; e.target.src = "https://placehold.co/100x100?text=No+Image"; }}
//                                                         alt="dish"
//                                                     />
//                                                     <button style={styles.findBtn} onClick={() => { setSearchQuery(item.name); setCurrentSearchIndex(idx); setShowImageFinder(true); }}>🔍 Better Image</button>
//                                                 </div>
//                                                 <div style={{flex:1}}>
//                                                     <div style={{display:'flex', gap:'10px'}}>
//                                                         <input style={styles.inputName} value={item.name} onChange={e=>{const nr=[...scanResults]; nr[idx].name=e.target.value; setScanResults(nr)}} />
//                                                         <select style={styles.typeSelect} value={item.is_veg} onChange={e=>{const nr=[...scanResults]; nr[idx].is_veg=e.target.value; setScanResults(nr)}}><option value="yes">Veg</option><option value="no">Non-Veg</option></select>
//                                                     </div>

//                                                     <div style={styles.basePriceRow}>
//                                                         <span style={styles.basePriceLabel}>Menu Price ₹</span>
//                                                         <input
//                                                             type="number"
//                                                             style={styles.inputPrice}
//                                                             value={item.price}
//                                                             onChange={e => { const nr=[...scanResults]; nr[idx].price = e.target.value; nr[idx].base_price = e.target.value; setScanResults(nr); }}
//                                                         />
//                                                         <span style={{color:'#fbbf24', fontSize:'11px'}}>Customer: ₹{customer}</span>
//                                                         <span style={{color:'#a855f7', fontSize:'11px'}}>Vendor: ₹{vendor}</span>
//                                                         <span style={{color:'#34d399', fontSize:'11px'}}>Profit: ₹{profit}</span>
//                                                         {(!item.price || item.price === 0) && (
//                                                             <span style={styles.priceWarning}>⚠ No price found — please check manually</span>
//                                                         )}
//                                                     </div>

//                                                     <textarea style={styles.inputDesc} value={item.description} onChange={e=>{const nr=[...scanResults]; nr[idx].description=e.target.value; setScanResults(nr)}} placeholder="Description..." />

//                                                     <div style={styles.variantBox}>
//                                                         <div style={{display:'flex', flexWrap:'wrap', gap:'8px'}}>
//                                                             {item.variants.map((v, vIdx) => {
//                                                                 const { customer: vCust, vendor: vVendor, profit: vProfit } = computeVariantPrices(v.price);
//                                                                 return (
//                                                                     <div key={vIdx} style={styles.vRow}>
//                                                                         <input style={styles.inputUnit} value={v.unit_value} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].unit_value=e.target.value; setScanResults(nr)}} />
//                                                                         <input style={styles.inputPrice} value={v.price} onChange={e=>{const nr=[...scanResults]; nr[idx].variants[vIdx].price=e.target.value; nr[idx].variants[vIdx].base_price=e.target.value; setScanResults(nr)}} />
//                                                                         <span style={{color:'#fbbf24', fontSize:'10px'}}>C:₹{vCust}</span>
//                                                                         <span style={{color:'#a855f7', fontSize:'10px'}}>V:₹{vVendor}</span>
//                                                                         <span style={{color:'#34d399', fontSize:'10px'}}>P:₹{vProfit}</span>
//                                                                         <button onClick={()=>{const nr=[...scanResults]; nr[idx].variants.splice(vIdx,1); setScanResults(nr)}} style={styles.delBtn}><X size={12}/></button>
//                                                                     </div>
//                                                                 );
//                                                             })}
//                                                             <button style={styles.addBtn} onClick={()=>{const nr=[...scanResults]; nr[idx].variants.push({unit_value:'New', price:0, base_price:0}); setScanResults(nr)}}>+ Price</button>
//                                                         </div>
//                                                     </div>
//                                                 </div>
//                                             </div>
//                                         </div>
//                                     );
//                                 })}
//                             </div>
//                         </>
//                     )}
//                 </div>
//             </div>

//             {showImageFinder && (
//                 <div onClick={e => e.stopPropagation()} style={{ position: 'relative', zIndex: 10000 }}>
//                     <ImageSearchModal isOpen={showImageFinder} onClose={()=>setShowImageFinder(false)} query={searchQuery} onSelect={handleImageSelect} />
//                 </div>
//             )}
//             <style>{`.loader { border: 4px solid #1e293b; border-top: 4px solid #a855f7; border-radius: 50%; width: 40px; height: 40px; animation: spin 1s linear infinite; margin: 0 auto; } @keyframes spin { 100% { transform: rotate(360deg); } }`}</style>
//         </div>
//     );
// };

// const styles = {
//     overlay: { position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' },
//     modal: { background: '#0a0a0a', width: '95%', maxWidth: '1100px', height: '85vh', borderRadius: '16px', border: '1px solid #1f1f1f', color: 'white', display: 'flex', flexDirection: 'column', overflow: 'hidden' },
//     header: { padding: '15px 20px', borderBottom: '1px solid #1f1f1f', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#0f0f0f' },
//     countBadge: { background: '#a855f722', color: '#a855f7', padding: '5px 12px', borderRadius: '20px', fontSize: '13px', fontWeight: 700, display: 'flex', alignItems: 'center', gap: '6px' },
//     aiIcon: { background: '#a855f7', padding: '8px', borderRadius: '8px' },
//     body: { flex: 1, overflowY: 'auto', padding: '20px' },
//     backBtn: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', fontWeight:600 },
//     backBtnLeft: { color:'#a855f7', background:'none', border:'none', cursor:'pointer', marginBottom:'15px', float:'left', fontWeight:600 },
//     sourceCard: { flex:1, minWidth:'220px', maxWidth:'300px', background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'16px', padding:'30px', textAlign:'center', cursor:'pointer', transition:'0.3s' },
//     grid: { display:'grid', gridTemplateColumns:'repeat(auto-fill, minmax(150px, 1fr))', gap:'15px' },
//     imgPick: { background:'#0f0f0f', border:'1px solid #1f1f1f', borderRadius:'12px', overflow:'hidden', cursor:'pointer' },
//     imgLabel: { fontSize:'10px', padding:'5px', textAlign:'center', background:'#161616', color:'#94a3b8' },
//     dropZone: { height: '220px', border: '2px dashed #1f1f1f', borderRadius: '12px', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', marginBottom: '20px', overflow:'hidden', clear:'both' },
//     btnPrimary: { background: '#a855f7', color: 'white', border: 'none', padding: '12px 40px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
//     itemCard: { background: '#0f0f0f', border: '1px solid #1f1f1f', borderRadius: '12px', padding: '15px' },
//     thumb: { width: '100px', height: '100px', borderRadius: '8px', objectFit: 'cover', border:'1px solid #1f1f1f' },
//     findBtn: { width:'100%', background: '#a855f722', border: 'none', color: '#a855f7', fontSize: '10px', padding: '6px', borderRadius: '4px', marginTop: '6px', cursor: 'pointer', fontWeight:600 },
//     inputName: { background: 'none', border: 'none', borderBottom: '1px solid #1f1f1f', color: 'white', fontSize: '18px', fontWeight: 700, flex: 1, outline: 'none' },
//     basePriceRow: { display: 'flex', alignItems: 'center', gap: '8px', marginTop: '10px', background: '#161616', border: '1px solid #334155', borderRadius: '8px', padding: '8px 10px', flexWrap: 'wrap' },
//     basePriceLabel: { color: '#a855f7', fontSize: '12px', fontWeight: 700 },
//     priceWarning: { color: '#f59e0b', fontSize: '11px', fontWeight: 600 },
//     inputDesc: { width: '100%', background: '#161616', border: '1px solid #1f1f1f', borderRadius: '8px', color: '#94a3b8', fontSize: '12px', padding: '10px', marginTop: '10px', resize: 'none', outline: 'none', minHeight:'50px' },
//     variantBox: { background: '#161616', padding: '10px', borderRadius: '8px', marginTop: '10px' },
//     vRow: { display: 'flex', alignItems: 'center', gap: '8px', background: '#0a0a0a', padding: '5px 10px', borderRadius: '6px', border: '1px solid #1f1f1f' },
//     inputUnit: { background: 'none', border: 'none', color: '#a855f7', width: '70px', fontSize: '12px', fontWeight: 'bold', outline: 'none' },
//     inputPrice: { background: '#1a1a1a', border: '1px solid #334155', borderRadius: '4px', color: 'white', width: '70px', padding: '4px', textAlign: 'center', fontSize: '12px', outline: 'none' },
//     btnBlue: { background: '#2563eb', color: 'white', border: 'none', padding: '12px 25px', borderRadius: '10px', fontWeight: 700, cursor: 'pointer' },
//     btnMagic: { background: 'none', border: '1px solid #a855f7', color: '#a855f7', padding: '10px 20px', borderRadius: '10px', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '5px', fontWeight:600 },
//     addBtn: { background: '#a855f722', border: '1px dashed #a855f7', color: '#a855f7', fontSize: '11px', padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontWeight:600 },
//     delBtn: { background:'none', border:'none', color:'#f87171', cursor:'pointer' },
//     typeSelect: { background: '#1a1a1a', color: 'white', border: '1px solid #334155', borderRadius: '6px', padding: '5px', fontSize: '12px' },
//     closeBtn: { background: 'none', border: 'none', color: '#64748b', cursor: 'pointer' }
// };

// export default AIScanModal;

import React, { useContext, useEffect, useRef, useState } from "react";
import {
  Image as ImageIcon,
  Sparkles,
  X,
  CloudUpload,
  History,
  ListCheck,
} from "lucide-react";

import {
  postData,
  getData,
  serverURL,
} from "../../../../services/Fetchnodeservices";
import { ThemeContext } from "../../../../context/ThemeContext";
import ImageSearchModal from "./ImageSearchModal";

const AIScanModal = ({
  isOpen,
  onClose,
  designationId,
  designation_id,
  restaurantName,
  onItemsAdded,
  onSuccess,
  preSelectedServerImage,
  preSelectedImage,
  markupCommission = 20,
  profitCommission = 20,
}) => {
  const themeContext = useContext(ThemeContext);
  const isDark = themeContext?.currentTheme === "dark";

  const fallbackTheme = {
    background: isDark ? "#0f172a" : "#f8fafc",
    surface: isDark ? "#1e293b" : "#ffffff",
    surfaceLighter: isDark ? "#334155" : "#f1f5f9",
    border: isDark ? "#475569" : "#e2e8f0",
    textPrimary: isDark ? "#f8fafc" : "#0f172a",
    textSecondary: isDark ? "#cbd5e1" : "#334155",
    textMuted: isDark ? "#94a3b8" : "#64748b",
    primary: "#6366f1",
    primaryLight: "rgba(99, 102, 241, 0.15)",
    primaryGradient: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  };

  const brandTheme = themeContext?.theme || fallbackTheme;

  const ts = {
    background: brandTheme.background || fallbackTheme.background,
    surface: brandTheme.surface || fallbackTheme.surface,
    surfaceLighter:
      brandTheme.surfaceLighter ||
      (isDark ? "#334155" : "#f1f5f9"),
    border: brandTheme.border || fallbackTheme.border,
    textPrimary: brandTheme.textPrimary || fallbackTheme.textPrimary,
    textSecondary: brandTheme.textSecondary || fallbackTheme.textSecondary,
    textMuted: brandTheme.textMuted || fallbackTheme.textMuted,
    primary: brandTheme.primary || fallbackTheme.primary,
    primaryLight: brandTheme.primaryLight || fallbackTheme.primaryLight,
    success: brandTheme.success || "#10b981",
    warning: brandTheme.warning || "#f59e0b",
    error: brandTheme.error || "#ef4444",
    gradientPrimary:
      brandTheme.primaryGradient ||
      `linear-gradient(135deg, ${brandTheme.primary || fallbackTheme.primary}, ${
        brandTheme.primaryDark || brandTheme.primary || fallbackTheme.primary
      })`,
  };

  // Supports both old and new prop names.
  const activeDesignationId = designationId || designation_id;
  const selectedServerImage =
    preSelectedServerImage || preSelectedImage;
  const handleItemsAdded = onItemsAdded || onSuccess || (() => {});

  const [step, setStep] = useState("select-source");
  const [loadingStep, setLoadingStep] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [serverFileName, setServerFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState("");
  const [scanResults, setScanResults] = useState([]);
  // The API intentionally separates new dishes from dishes already stored in
  // this restaurant's menu. Keep the latter visible, but never submit them
  // again; this makes a full scan transparent and prevents duplicates.
  const [scanSummary, setScanSummary] = useState({ total: 0, alreadyInMenu: [] });
  const [vendorImages, setVendorImages] = useState([]);
  const [loadingImages, setLoadingImages] = useState(false);
  const [saving, setSaving] = useState(false);
  const [isBulkSearching, setIsBulkSearching] = useState(false);
  const [showImageFinder, setShowImageFinder] = useState(false);
  const [currentSearchIndex, setCurrentSearchIndex] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const fileInputRef = useRef(null);

  useEffect(() => {
    if (!isOpen) return;

    if (selectedServerImage) {
      setServerFileName(selectedServerImage);
      setPreviewUrl(`${serverURL}/uploads/${selectedServerImage}`);
      setStep("upload");
    } else {
      setStep("select-source");
      setServerFileName("");
      setSelectedFile(null);
      setPreviewUrl("");
    }

    setScanResults([]);
    setScanSummary({ total: 0, alreadyInMenu: [] });
  }, [isOpen, selectedServerImage]);

  const computePrices = (menuPrice) => {
    const menu = parseFloat(menuPrice) || 0;
    const customer = Math.round(menu * (1 + markupCommission / 100));
    const profit = Math.round(customer * (profitCommission / 100));
    const vendor = customer - profit;

    return { menu, customer, vendor, profit };
  };

  const computeVariantPrices = (menuPrice) => {
    const menu = parseFloat(menuPrice) || 0;
    const customer = Math.round(menu * (1 + markupCommission / 100));
    const profit = Math.round(customer * (profitCommission / 100));
    const vendor = customer - profit;

    return { customer, vendor, profit };
  };

  const updateItem = (itemIndex, updater) => {
    setScanResults((previous) =>
      previous.map((item, index) =>
        index === itemIndex ? updater({ ...item }) : item
      )
    );
  };

  const autoFetchAllImages = async () => {
    setIsBulkSearching(true);

    const updatedItems = [...scanResults];

    for (let index = 0; index < updatedItems.length; index += 1) {
      try {
        setLoadingStep(
          `✨ Finding image for: ${updatedItems[index].name}...`
        );

        const response = await postData("aimenu/search-web-images", {
          query: updatedItems[index].name,
        });

        if (response?.success && response.images?.length > 0) {
          updatedItems[index].pic1 = response.images[0].url;
          setScanResults([...updatedItems]);
        }
      } catch (error) {
        console.error("Image search failed:", error);
      }
    }

    setIsBulkSearching(false);
    setLoadingStep("");
  };

  const fetchVendorImages = async () => {
    if (!activeDesignationId) return;

    setLoadingImages(true);
    setStep("vendor-images");

    try {
      const response = await getData(
        `menuScanner/requests-by-restaurant/${activeDesignationId}`
      );

      if (response?.success) {
        const allFiles = [];

        response.data.forEach((request) => {
          let files = [];

          try {
            files = Array.isArray(request.files)
              ? request.files
              : JSON.parse(request.files || "[]");
          } catch {
            files = [];
          }

          files.forEach((file) => {
            if (file.type === "image") {
              allFiles.push({
                ...file,
                created_at: request.created_at,
              });
            }
          });
        });

        setVendorImages(allFiles);
      }
    } catch (error) {
      console.error("Vendor images fetch failed:", error);
    } finally {
      setLoadingImages(false);
    }
  };

  const handleVendorImageSelect = (filename) => {
    setServerFileName(filename);
    setSelectedFile(null);
    setPreviewUrl(`${serverURL}/uploads/${filename}`);
    setStep("upload");
  };

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setSelectedFile(file);
    setServerFileName("");
    setPreviewUrl(URL.createObjectURL(file));
  };

  const startScan = async () => {
    if (!selectedFile && !serverFileName) {
      alert("Please select a menu image first.");
      return;
    }

    setStep("scanning");
    setLoadingStep("🧠 AI is reading the menu...");

    const formData = new FormData();

    if (selectedFile) {
      formData.append("file", selectedFile);
    } else {
      formData.append("serverFileName", serverFileName);
    }

    formData.append("designation_id", activeDesignationId);
    formData.append(
      "instructions",
      "Extract item names, prices, variants, veg/non-veg, and a short description."
    );

    try {
      const response = await postData("aimenu/ai-scan", formData);

      if (response?.success) {
        setScanResults(
          (response.new_items || []).map((item) => ({
            ...item,
            tempId: Math.random().toString(36).slice(2, 11),
            selected: true,
            price: item.price || 0,
            base_price: item.price || 0,
            variants:
              item.variants?.map((variant) => ({
                ...variant,
                price:
                  variant.price ||
                  variant.item_price_variant ||
                  0,
                base_price:
                  variant.price ||
                  variant.item_price_variant ||
                  0,
              })) || [],
            description: item.description || "",
          }))
        );
        setScanSummary({
          total: Number(response.total) ||
            (response.new_items || []).length +
              (response.already_in_menu || []).length,
          alreadyInMenu: response.already_in_menu || [],
        });

        setStep("results");
      } else {
        setStep("select-source");
      }
    } catch (error) {
      console.error("AI scan failed:", error);
      setStep("select-source");
    }
  };

  const handleSaveItems = async () => {
    const finalItems = scanResults
      .filter((item) => item.selected)
      .map((item) => {
        const menuPrice = parseFloat(item.price) || 0;
        const prices = computePrices(menuPrice);

        const formattedVariants = (item.variants || []).map((variant) => {
          const variantMenuPrice = parseFloat(variant.price) || 0;
          const variantPrices = computeVariantPrices(variantMenuPrice);

          return {
            unit: (variant.unit_value || "Price").toLowerCase(),
            unit_value: variant.unit_value || "Price",
            base_price: variantMenuPrice,
            actual_price: variantMenuPrice,
            item_price_variant: variantPrices.customer,
            is_available_variant: "yes",
          };
        });

        return {
          ...item,
          base_price: menuPrice,
          requested_price: menuPrice,
          price: prices.customer,
          status: "1",
          source: "ai_scan",
          variant: formattedVariants,
          description: item.description || "",
        };
      });

    if (!finalItems.length) {
      alert("Please keep at least one menu item.");
      return;
    }

    setSaving(true);

    try {
      const response = await postData(
        `menu/direct-items/${activeDesignationId}`,
        { items: finalItems }
      );

      if (response?.success) {
        handleItemsAdded();
        onClose();
      }
    } catch (error) {
      console.error("Save items failed:", error);
    } finally {
      setSaving(false);
    }
  };

  const handleImageSelect = (imageUrl) => {
    if (currentSearchIndex !== null) {
      updateItem(currentSearchIndex, (item) => ({
        ...item,
        pic1: imageUrl,
      }));
    }

    setShowImageFinder(false);
  };

  const styles = {
    overlay: {
      position: "fixed",
      inset: 0,
      background: "rgba(0, 0, 0, 0.72)",
      zIndex: 9999,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backdropFilter: "blur(5px)",
    },
    modal: {
      background: ts.surface,
      width: "95%",
      maxWidth: "1100px",
      height: "85vh",
      borderRadius: "16px",
      border: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      display: "flex",
      flexDirection: "column",
      overflow: "hidden",
      boxShadow: "0 20px 60px rgba(0, 0, 0, 0.35)",
    },
    header: {
      padding: "15px 20px",
      borderBottom: `1px solid ${ts.border}`,
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      background: ts.surfaceLighter,
    },
    countBadge: {
      background: ts.primaryLight,
      color: ts.primary,
      padding: "5px 12px",
      borderRadius: "20px",
      fontSize: "13px",
      fontWeight: 700,
      display: "flex",
      alignItems: "center",
      gap: "6px",
    },
    aiIcon: {
      background: ts.gradientPrimary,
      padding: "8px",
      borderRadius: "8px",
      display: "flex",
    },
    body: {
      flex: 1,
      overflowY: "auto",
      padding: "20px",
    },
    backBtn: {
      color: ts.primary,
      background: "none",
      border: "none",
      cursor: "pointer",
      marginBottom: "15px",
      fontWeight: 600,
    },
    backBtnLeft: {
      color: ts.primary,
      background: "none",
      border: "none",
      cursor: "pointer",
      marginBottom: "15px",
      float: "left",
      fontWeight: 600,
    },
    sourceCard: {
      flex: 1,
      minWidth: "220px",
      maxWidth: "300px",
      background: ts.surfaceLighter,
      border: `1px solid ${ts.border}`,
      borderRadius: "16px",
      padding: "30px",
      textAlign: "center",
      cursor: "pointer",
      transition: "0.3s",
    },
    grid: {
      display: "grid",
      gridTemplateColumns: "repeat(auto-fill, minmax(150px, 1fr))",
      gap: "15px",
    },
    imgPick: {
      background: ts.surfaceLighter,
      border: `1px solid ${ts.border}`,
      borderRadius: "12px",
      overflow: "hidden",
      cursor: "pointer",
    },
    imgLabel: {
      fontSize: "10px",
      padding: "5px",
      textAlign: "center",
      background: ts.surface,
      color: ts.textMuted,
    },
    dropZone: {
      height: "220px",
      border: `2px dashed ${ts.border}`,
      borderRadius: "12px",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      cursor: "pointer",
      marginBottom: "20px",
      overflow: "hidden",
      clear: "both",
      background: ts.surfaceLighter,
    },
    btnPrimary: {
      background: ts.gradientPrimary,
      color: "#ffffff",
      border: "none",
      padding: "12px 40px",
      borderRadius: "10px",
      fontWeight: 700,
      cursor: "pointer",
    },
    itemCard: {
      background: ts.surfaceLighter,
      border: `1px solid ${ts.border}`,
      borderRadius: "12px",
      padding: "15px",
    },
    thumb: {
      width: "100px",
      height: "100px",
      borderRadius: "8px",
      objectFit: "cover",
      border: `1px solid ${ts.border}`,
    },
    findBtn: {
      width: "100%",
      background: ts.primaryLight,
      border: "none",
      color: ts.primary,
      fontSize: "10px",
      padding: "6px",
      borderRadius: "4px",
      marginTop: "6px",
      cursor: "pointer",
      fontWeight: 600,
    },
    inputName: {
      background: "transparent",
      border: "none",
      borderBottom: `1px solid ${ts.border}`,
      color: ts.textPrimary,
      fontSize: "18px",
      fontWeight: 700,
      flex: 1,
      outline: "none",
    },
    basePriceRow: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      marginTop: "10px",
      background: ts.surface,
      border: `1px solid ${ts.border}`,
      borderRadius: "8px",
      padding: "8px 10px",
      flexWrap: "wrap",
    },
    basePriceLabel: {
      color: ts.primary,
      fontSize: "12px",
      fontWeight: 700,
    },
    priceWarning: {
      color: ts.warning,
      fontSize: "11px",
      fontWeight: 600,
    },
    inputDesc: {
      width: "100%",
      boxSizing: "border-box",
      background: ts.surface,
      border: `1px solid ${ts.border}`,
      borderRadius: "8px",
      color: ts.textSecondary,
      fontSize: "12px",
      padding: "10px",
      marginTop: "10px",
      resize: "none",
      outline: "none",
      minHeight: "50px",
    },
    variantBox: {
      background: ts.surface,
      padding: "10px",
      borderRadius: "8px",
      marginTop: "10px",
      border: `1px solid ${ts.border}`,
    },
    vRow: {
      display: "flex",
      alignItems: "center",
      gap: "8px",
      background: ts.surfaceLighter,
      padding: "5px 10px",
      borderRadius: "6px",
      border: `1px solid ${ts.border}`,
    },
    inputUnit: {
      background: "transparent",
      border: "none",
      color: ts.primary,
      width: "70px",
      fontSize: "12px",
      fontWeight: "bold",
      outline: "none",
    },
    inputPrice: {
      background: ts.surface,
      border: `1px solid ${ts.border}`,
      borderRadius: "4px",
      color: ts.textPrimary,
      width: "70px",
      padding: "4px",
      textAlign: "center",
      fontSize: "12px",
      outline: "none",
    },
    btnBlue: {
      background: ts.gradientPrimary,
      color: "#ffffff",
      border: "none",
      padding: "12px 25px",
      borderRadius: "10px",
      fontWeight: 700,
      cursor: "pointer",
    },
    btnMagic: {
      background: "transparent",
      border: `1px solid ${ts.primary}`,
      color: ts.primary,
      padding: "10px 20px",
      borderRadius: "10px",
      cursor: "pointer",
      display: "flex",
      alignItems: "center",
      gap: "5px",
      fontWeight: 600,
    },
    addBtn: {
      background: ts.primaryLight,
      border: `1px dashed ${ts.primary}`,
      color: ts.primary,
      fontSize: "11px",
      padding: "6px 12px",
      borderRadius: "6px",
      cursor: "pointer",
      fontWeight: 600,
    },
    delBtn: {
      background: "none",
      border: "none",
      color: ts.error,
      cursor: "pointer",
    },
    typeSelect: {
      background: ts.surface,
      color: ts.textPrimary,
      border: `1px solid ${ts.border}`,
      borderRadius: "6px",
      padding: "5px",
      fontSize: "12px",
    },
    closeBtn: {
      background: "none",
      border: "none",
      color: ts.textMuted,
      cursor: "pointer",
    },
  };

  if (!isOpen) return null;

  return (
    <div
      style={styles.overlay}
      onClick={showImageFinder ? undefined : onClose}
    >
      <div style={styles.modal} onClick={(event) => event.stopPropagation()}>
        <div style={styles.header}>
          <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
            <div style={styles.aiIcon}>
              <Sparkles size={18} fill="#ffffff" color="#ffffff" />
            </div>

            <h3 style={{ margin: 0, fontSize: "18px" }}>
              🤖 AI Scanner {restaurantName ? `– ${restaurantName}` : ""}
            </h3>
          </div>

          {scanSummary.total > 0 && (
            <div style={styles.countBadge}>
              <ListCheck size={14} /> {scanSummary.total} items scanned
            </div>
          )}

          <button type="button" onClick={onClose} style={styles.closeBtn}>
            <X />
          </button>
        </div>

        <div style={styles.body}>
          {step === "select-source" ? (
            <div
              style={{
                display: "flex",
                gap: "20px",
                justifyContent: "center",
                padding: "40px",
                flexWrap: "wrap",
              }}
            >
              <div
                style={styles.sourceCard}
                onClick={() => setStep("upload")}
              >
                <CloudUpload size={40} color={ts.primary} />
                <h3 style={{ color: ts.textPrimary }}>Upload File</h3>
                <p style={{ color: ts.textMuted }}>From your device</p>
              </div>

              <div style={styles.sourceCard} onClick={fetchVendorImages}>
                <History size={40} color={ts.primary} />
                <h3 style={{ color: ts.textPrimary }}>Vendor Menu</h3>
                <p style={{ color: ts.textMuted }}>Previously uploaded</p>
              </div>
            </div>
          ) : step === "vendor-images" ? (
            <div>
              <button
                type="button"
                onClick={() => setStep("select-source")}
                style={styles.backBtn}
              >
                ← Back
              </button>

              {loadingImages ? (
                <div className="ai-loader" />
              ) : vendorImages.length > 0 ? (
                <div style={styles.grid}>
                  {vendorImages.map((image, index) => (
                    <div
                      key={`${image.name}-${index}`}
                      style={styles.imgPick}
                      onClick={() => handleVendorImageSelect(image.name)}
                    >
                      <img
                        src={`${serverURL}/uploads/${image.name}`}
                        alt="Vendor menu"
                        style={{
                          width: "100%",
                          height: "120px",
                          objectFit: "cover",
                        }}
                      />

                      <div style={styles.imgLabel}>
                        {new Date(image.created_at).toLocaleDateString()}
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ color: ts.textMuted, textAlign: "center" }}>
                  No vendor menu images found.
                </p>
              )}
            </div>
          ) : step === "upload" ? (
            <div style={{ textAlign: "center" }}>
              <button
                type="button"
                onClick={() => setStep("select-source")}
                style={styles.backBtnLeft}
              >
                ← Change
              </button>

              <div
                style={styles.dropZone}
                onClick={() => {
                  if (!serverFileName) fileInputRef.current?.click();
                }}
              >
                <input
                  type="file"
                  accept="image/*,.pdf"
                  ref={fileInputRef}
                  onChange={handleFileChange}
                  hidden
                />

                {previewUrl ? (
                  <img
                    src={previewUrl}
                    style={{
                      maxHeight: "100%",
                      maxWidth: "100%",
                      borderRadius: "8px",
                      objectFit: "contain",
                    }}
                    alt="Menu preview"
                  />
                ) : (
                  <ImageIcon size={48} color={ts.textMuted} />
                )}
              </div>

              <button
                type="button"
                style={styles.btnPrimary}
                onClick={startScan}
              >
                🔍 Start AI Scan
              </button>
            </div>
          ) : step === "scanning" || isBulkSearching ? (
            <div style={{ textAlign: "center", padding: "80px" }}>
              <div className="ai-loader" />
              <h3 style={{ marginTop: "20px", color: ts.primary }}>
                {loadingStep}
              </h3>
            </div>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  marginBottom: "20px",
                  alignItems: "center",
                  justifyContent: "space-between",
                  flexWrap: "wrap",
                }}
              >
                <div style={{ display: "flex", gap: "10px" }}>
                  <button
                    type="button"
                    style={styles.btnBlue}
                    disabled={saving}
                    onClick={handleSaveItems}
                  >
                    {saving ? "Saving..." : "💾 Add Items"}
                  </button>

                  <button
                    type="button"
                    style={styles.btnMagic}
                    disabled={isBulkSearching}
                    onClick={autoFetchAllImages}
                  >
                    <Sparkles size={14} /> ✨ Auto Images
                  </button>
                </div>

                <div style={{ color: ts.textMuted, fontSize: "14px", fontWeight: 600 }}>
                  {scanSummary.total || scanResults.length} scanned · {scanResults.length} new
                </div>
              </div>

              {scanSummary.alreadyInMenu.length > 0 && (
                <div
                  style={{
                    marginBottom: "16px",
                    padding: "12px 14px",
                    borderRadius: "10px",
                    border: `1px solid ${ts.success}55`,
                    background: `${ts.success}12`,
                    color: ts.textSecondary,
                    fontSize: "13px",
                    lineHeight: 1.55,
                  }}
                >
                  <strong style={{ color: ts.success }}>
                    ✓ {scanSummary.alreadyInMenu.length} item(s) already saved in this menu
                  </strong>
                  <div style={{ marginTop: "5px" }}>
                    {scanSummary.alreadyInMenu
                      .map((item) => item.name)
                      .filter(Boolean)
                      .join(" • ")}
                  </div>
                  <div style={{ marginTop: "5px", color: ts.textMuted }}>
                    They are not added again, so duplicate menu items will not be created.
                  </div>
                </div>
              )}

              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {scanResults.map((item, itemIndex) => {
                  const { customer, vendor, profit } = computePrices(item.price);

                  return (
                    <div key={item.tempId} style={styles.itemCard}>
                      <div style={{ display: "flex", gap: "15px" }}>
                        <div style={{ width: "110px", textAlign: "center" }}>
                          <img
                            src={
                              item.pic1?.startsWith("http")
                                ? item.pic1
                                : `${serverURL}/uploads/${item.pic1}`
                            }
                            style={styles.thumb}
                            alt={item.name || "Dish"}
                            onError={(event) => {
                              event.currentTarget.onerror = null;
                              event.currentTarget.src =
                                "https://placehold.co/100x100?text=No+Image";
                            }}
                          />

                          <button
                            type="button"
                            style={styles.findBtn}
                            onClick={() => {
                              setSearchQuery(item.name);
                              setCurrentSearchIndex(itemIndex);
                              setShowImageFinder(true);
                            }}
                          >
                            🔍 Better Image
                          </button>
                        </div>

                        <div style={{ flex: 1 }}>
                          <div style={{ display: "flex", gap: "10px" }}>
                            <input
                              style={styles.inputName}
                              value={item.name || ""}
                              onChange={(event) =>
                                updateItem(itemIndex, (currentItem) => ({
                                  ...currentItem,
                                  name: event.target.value,
                                }))
                              }
                            />

                            <select
                              style={styles.typeSelect}
                              value={item.is_veg || "yes"}
                              onChange={(event) =>
                                updateItem(itemIndex, (currentItem) => ({
                                  ...currentItem,
                                  is_veg: event.target.value,
                                }))
                              }
                            >
                              <option value="yes">Veg</option>
                              <option value="no">Non-Veg</option>
                            </select>

                            <button
                              type="button"
                              title="Remove this dish from the scan results"
                              onClick={() =>
                                setScanResults((previous) =>
                                  previous.filter(
                                    (_, index) => index !== itemIndex
                                  )
                                )
                              }
                              style={{
                                display: "inline-flex",
                                alignItems: "center",
                                justifyContent: "center",
                                gap: "5px",
                                minWidth: "92px",
                                border: `1px solid ${ts.error}55`,
                                borderRadius: "8px",
                                padding: "0 10px",
                                background: ts.errorLight,
                                color: ts.error,
                                cursor: "pointer",
                                fontSize: "12px",
                                fontWeight: 700,
                              }}
                            >
                              <X size={14} /> Remove
                            </button>
                          </div>

                          <div style={styles.basePriceRow}>
                            <span style={styles.basePriceLabel}>Menu Price ₹</span>

                            <input
                              type="number"
                              style={styles.inputPrice}
                              value={item.price}
                              onChange={(event) =>
                                updateItem(itemIndex, (currentItem) => ({
                                  ...currentItem,
                                  price: event.target.value,
                                  base_price: event.target.value,
                                }))
                              }
                            />

                            <span style={{ color: ts.warning, fontSize: "11px" }}>
                              Customer: ₹{customer}
                            </span>

                            <span style={{ color: ts.primary, fontSize: "11px" }}>
                              Vendor: ₹{vendor}
                            </span>

                            <span style={{ color: ts.success, fontSize: "11px" }}>
                              Profit: ₹{profit}
                            </span>

                            {(!item.price || Number(item.price) === 0) && (
                              <span style={styles.priceWarning}>
                                ⚠ No price found — please check manually
                              </span>
                            )}
                          </div>

                          <textarea
                            style={styles.inputDesc}
                            value={item.description || ""}
                            onChange={(event) =>
                              updateItem(itemIndex, (currentItem) => ({
                                ...currentItem,
                                description: event.target.value,
                              }))
                            }
                            placeholder="Description..."
                          />

                          <div style={styles.variantBox}>
                            <div
                              style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "8px",
                              }}
                            >
                              {(item.variants || []).map(
                                (variant, variantIndex) => {
                                  const variantPrices = computeVariantPrices(
                                    variant.price
                                  );

                                  return (
                                    <div key={variantIndex} style={styles.vRow}>
                                      <input
                                        style={styles.inputUnit}
                                        value={variant.unit_value || ""}
                                        onChange={(event) =>
                                          updateItem(
                                            itemIndex,
                                            (currentItem) => {
                                              const variants = [
                                                ...(currentItem.variants || []),
                                              ];

                                              variants[variantIndex] = {
                                                ...variants[variantIndex],
                                                unit_value: event.target.value,
                                              };

                                              return {
                                                ...currentItem,
                                                variants,
                                              };
                                            }
                                          )
                                        }
                                      />

                                      <input
                                        type="number"
                                        style={styles.inputPrice}
                                        value={variant.price}
                                        onChange={(event) =>
                                          updateItem(
                                            itemIndex,
                                            (currentItem) => {
                                              const variants = [
                                                ...(currentItem.variants || []),
                                              ];

                                              variants[variantIndex] = {
                                                ...variants[variantIndex],
                                                price: event.target.value,
                                                base_price: event.target.value,
                                              };

                                              return {
                                                ...currentItem,
                                                variants,
                                              };
                                            }
                                          )
                                        }
                                      />

                                      <span
                                        style={{
                                          color: ts.warning,
                                          fontSize: "10px",
                                        }}
                                      >
                                        C:₹{variantPrices.customer}
                                      </span>

                                      <span
                                        style={{
                                          color: ts.primary,
                                          fontSize: "10px",
                                        }}
                                      >
                                        V:₹{variantPrices.vendor}
                                      </span>

                                      <span
                                        style={{
                                          color: ts.success,
                                          fontSize: "10px",
                                        }}
                                      >
                                        P:₹{variantPrices.profit}
                                      </span>

                                      <button
                                        type="button"
                                        style={styles.delBtn}
                                        onClick={() =>
                                          updateItem(
                                            itemIndex,
                                            (currentItem) => ({
                                              ...currentItem,
                                              variants: (
                                                currentItem.variants || []
                                              ).filter(
                                                (_, index) =>
                                                  index !== variantIndex
                                              ),
                                            })
                                          )
                                        }
                                      >
                                        <X size={12} />
                                      </button>
                                    </div>
                                  );
                                }
                              )}

                              <button
                                type="button"
                                style={styles.addBtn}
                                onClick={() =>
                                  updateItem(itemIndex, (currentItem) => ({
                                    ...currentItem,
                                    variants: [
                                      ...(currentItem.variants || []),
                                      {
                                        unit_value: "New",
                                        price: 0,
                                        base_price: 0,
                                      },
                                    ],
                                  }))
                                }
                              >
                                + Price
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </>
          )}
        </div>
      </div>

      {showImageFinder && (
        <div
          onClick={(event) => event.stopPropagation()}
          style={{ position: "relative", zIndex: 10000 }}
        >
          <ImageSearchModal
            isOpen={showImageFinder}
            onClose={() => setShowImageFinder(false)}
            query={searchQuery}
            onSelect={handleImageSelect}
          />
        </div>
      )}

      <style>{`
        .ai-loader {
          border: 4px solid ${ts.border};
          border-top: 4px solid ${ts.primary};
          border-radius: 50%;
          width: 40px;
          height: 40px;
          animation: ai-spin 1s linear infinite;
          margin: 0 auto;
        }

        @keyframes ai-spin {
          100% {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default AIScanModal;
